import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDashboard = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	"data-name": "Layer 1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 25 25",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: "\n      .dashboard-cls-2 {\n        fill: transparent;\n      }\n\n      .dashboard-cls-3 {\n        fill: currentColor;\n      }\n\n      .dashboard-cls-4 {\n        fill: currentColor;\n      }\n    " }) }),
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
			className: "dashboard-cls-2",
			d: "M24.357,25H.643A.643.643,0,0,1,0,24.357V.643A.643.643,0,0,1,.643,0H24.357A.643.643,0,0,1,25,.643V24.357A.643.643,0,0,1,24.357,25Z"
		}) }),
		/* @__PURE__ */ _jsx("rect", {
			className: "dashboard-cls-3",
			x: 5.522,
			y: 16.883,
			width: 13.956,
			height: 2.594
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "dashboard-cls-3",
			d: "M11.2,13.8H13.8V11.2h0V8.117h0v-2.6H5.522V11.2h0V13.8ZM8.117,11.2V8.117H11.2V11.2Z"
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "dashboard-cls-3",
			x: 16.883,
			y: 5.522,
			width: 2.595,
			height: 8.275
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "dashboard-cls-4",
			d: "M24.357,0H22.564V1.286h1.15V23.714H1.286V1.286H13.8V0H.643A.643.643,0,0,0,0,.643V24.357A.643.643,0,0,0,.643,25H24.357A.643.643,0,0,0,25,24.357V.643A.643.643,0,0,0,24.357,0Z"
		})
	]
});
export default SvgDashboard;
